<template>
    <div class="text-align">
        <div v-show="isLoadPlatform" style="text-align: center !important">
            <div style="margin-top: 15%" class="spinner spinner-md"></div>
            <br />
            <label>{{ $t("AUTHORIZATIONDOCSIGN.loadingPlatforms") }}</label>
        </div>
        <div v-show="isAuthorizing" style="text-align: center !important">
            <div v-show="isWaitingAuthorization">
                <div style="margin-top: 15%" class="spinner spinner-md"></div>
                <br />
                <label>{{ $t("AUTHORIZATIONDOCSIGN.awaitingAuthorization") }}</label>
            </div>
        </div>
        <div v-show="!isAuthorizing && !isLoadPlatform">
            <!-- Docusing -->
            <div class="p-2">
                <label>{{ $t("AUTHORIZATIONDOCSIGN.integrationKey") }}</label>
                <div class="small text-muted mb-2">
                    {{ $t("AUTHORIZATIONDOCSIGN.docuSignIntegrationKeyDescription") }}
                    <a target="_blank"
                       href=" https://support.docusign.com/br/guides/ndse-admin-guide-api-and-keys">{{ $t("AUTHORIZATIONDOCSIGN.details") }}</a>
                </div>
                <input v-model="platforms.docuSignData.integrationKey"
                       v-on:keypress="platforms.docuSignData.integrationKeyIsErr = false"
                       type="password"
                       class="form-control" />
            </div>
            <div class="p-2">
                <label>{{ $t("AUTHORIZATIONDOCSIGN.secretKey") }}</label>
                <div class="small text-muted mb-2">
                    {{ $t("AUTHORIZATIONDOCSIGN.docuSignSecretKeyDescription") }}
                </div>
                <input v-model="platforms.docuSignData.secretKey"
                       v-on:keypress="platforms.docuSignData.secretKeyIsErr = false"
                       type="password"
                       class="form-control" />
            </div>
            <div class="form p-2">
                <button v-on:click="DocuSignOnClickAuthorize()"
                        type="button"
                        class="btn btn-primary">
                    {{ $t("AUTHORIZATIONDOCSIGN.Authorize") }}
                </button>
            </div>
            <!-- Docusing - Fim -->
            <!-- Docusing Demo -->
            <div class="p-2">
                <label>DocuSign Demo</label>
                <br />
                <label>{{ $t("AUTHORIZATIONDOCSIGN.integrationKey") }}</label>
                <div class="small text-muted mb-2">
                    {{ $t("AUTHORIZATIONDOCSIGN.docuSignIntegrationKeyDescription") }}
                    <a target="_blank"
                       href=" https://support.docusign.com/br/guides/ndse-admin-guide-api-and-keys">{{ $t("AUTHORIZATIONDOCSIGN.details") }}</a>
                </div>
                <input v-model="platforms.docuSignDemoData.integrationKey"
                       v-on:keypress="
              platforms.docuSignDemoData.integrationKeyIsErr = false"
                       type="password"
                       class="form-control" />
            </div>

            <div class="p-2">
                <label>{{ $t("AUTHORIZATIONDOCSIGN.secretKey") }}</label>
                <div class="small text-muted mb-2">
                    {{ $t("AUTHORIZATIONDOCSIGN.docuSignSecretKeyDescription") }}
                </div>
                <input v-model="platforms.docuSignDemoData.secretKey"
                       v-on:keypress="platforms.docuSignDemoData.secretKeyIsErr = false"
                       type="password"
                       class="form-control" />
            </div>
            <div class="p-2">
                <button v-on:click="DocuSignDemoOnClickAuthorize()"
                        type="button"
                        class="btn btn-primary">
                    {{ $t("AUTHORIZATIONDOCSIGN.Authorize") }}
                </button>
            </div>
        </div>
        <!-- Docusing Demo - Fim -->
    </div>
</template>


<script>
    import SharedMixin from "./../mixins/SharedMethods.js";
    import PlatformUids from "../shared/platformUids.js";

    export default {
        name: "AuthorizationDocuSign",
        mixins: [SharedMixin],
        props: {
            msg: String,
            language: String,
        },
        data() {
            return {
                platformUids: PlatformUids,
                codeZeev: "",
                isAuthorizing: false,
                isLoadPlatform: false,
                isWaitingAuthorization: false,
                isAuthorizingErr: false,
                msgTimeout: 5,
                displayMsgTimeout: 0,

                platforms: {
                    list: [],
                    docuSignData: {
                        uId: PlatformUids.DocuSign,
                        name: "",
                        integrationKey: "",
                        integrationKeyIsErr: false,
                        secretKey: "",
                        secretKeyIsErr: false,
                        hrefUriCode: "",
                        code: "",
                        urlRedirect: window.location.host,
                    },
                    docuSignDemoData: {
                        uId: PlatformUids.DocuSignDemo,
                        name: "",
                        integrationKey: "",
                        integrationKeyIsErr: false,
                        secretKey: "",
                        secretKeyIsErr: false,
                        hrefUriCode: "",
                        code: "",
                        urlRedirect: "http://localhost:5000/",
                    },
                },
            };
        },
        watch: {},
        created() {
            var lang = this.$route.params.lang;
            this.setLanguage(lang);
            this.$i18n.locale = lang;
            this.OnLoadAuthorize();
        },
        methods: {
            PlatformGetAll: function () {
                let url =
                    this.fullTopUrlWithoutAppCode() +
                    "/internal/v1/authorization/" +
                    this.codeZeev;
                this.isLoadPlatform = true;
                try {
                    this.$http.get(url).then((response) => {
                        this.platforms.list = response.body;

                        var docuSignData = response.body.filter(
                            (platform) => platform.uid == this.platforms.docuSignData.uId
                        );

                        var docuSignDemoData = response.body.filter(
                            (platform) => platform.uid == this.platforms.docuSignDemoData.uId
                        );

                        if (docuSignData != undefined) this.DocuSignLoadData(docuSignData);
                        if (docuSignDemoData != undefined)
                            this.DocuSignDemoLoadData(docuSignDemoData);

                        this.isLoadPlatform = false;
                    });
                } catch (error) {
                    console.error("Erro ao buscar a lista de plataformas: " + error);
                    this.isLoadPlatform = false;
                }
            },
            DocuSignOnClickAuthorize: function () {
                if (!this.DocuSignIsDataValid()) return;

                localStorage.removeItem("isDocuSignErr");

                this.isAuthorizing = true;
                this.isWaitingAuthorization = true;

                localStorage.setItem(
                    "integrationKeyDocuSign",
                    this.platforms.docuSignData.integrationKey
                );
                localStorage.setItem(
                    "secretKeyDocuSign",
                    this.platforms.docuSignData.secretKey
                );
                localStorage.setItem(
                    "platformUidDocuSign",
                    this.platforms.docuSignData.uId
                );

                let urlDocuSign =
                    this.platforms.docuSignData.url +
                    this.platforms.docuSignData.oAuthMethod +
                    "?response_type=code&scope=signature&client_id=" +
                    this.platforms.docuSignData.integrationKey +
                    "&redirect_uri=" +
                    encodeURIComponent(window.location.origin + "/authorization/");

                var childWindow = window.open(urlDocuSign);

                localStorage.setItem("isDocuSignErr", true);

                var self = this;

                var timer = setInterval(function () {
                    var msg;
                    if (childWindow.closed) {
                        if (localStorage.getItem("isDocuSignErr") == "true") {
                            self.isAuthorizingErr = true;
                            msg = {
                                type: "warning",
                                text: self.$t("AUTHORIZATIONDOCSIGN.authorizingError"),
                            };
                            window.parent.postMessage(msg, "*");
                            console.warn(localStorage.getItem("errMsg"));
                        } else {
                            self.isAuthorizingErr = false;

                            msg = {
                                type: "success",
                                text: self.$t("AUTHORIZATIONDOCSIGN.authorized"),
                            };
                            window.parent.postMessage(msg, "*");
                        }

                        self.isWaitingAuthorization = false;

                        clearInterval(timer);

                        self.isAuthorizing = false;

                        localStorage.removeItem("isDocuSignErr");
                        localStorage.removeItem("platformUidDocuSign");
                    }
                }, 1000);
            },
            DocuSignIsDataValid() {
                var msg = "";
                if (
                    !this.platforms.docuSignData.integrationKey ||
                    this.platforms.docuSignData.integrationKey.trim().length === 0
                ) {
                    this.platforms.docuSignData.integrationKeyIsErr = true;
                    msg = {
                        type: "danger",
                        text: this.$t("AUTHORIZATIONDOCSIGN.validations.docuSign.integrationKey"),
                    };
                    window.parent.postMessage(msg, "*");
                    return false;
                } else this.platforms.docuSignData.integrationKeyIsErr = false;

                if (
                    !this.platforms.docuSignData.secretKey ||
                    this.platforms.docuSignData.secretKey.trim().length === 0
                ) {
                    this.platforms.docuSignData.secretKeyIsErr = true;
                    msg = {
                        type: "danger",
                        text: this.$t("AUTHORIZATIONDOCSIGN.validations.docuSign.secretKey"),
                    };
                    window.parent.postMessage(msg, "*");
                } else this.platforms.docuSignData.secretKeyIsErr = false;

                if (
                    this.platforms.docuSignData.integrationKeyIsErr ||
                    this.platforms.docuSignData.secretKeyIsErr
                )
                    return false;
                else return true;
            },
            DocuSignLoadData: function (docusignData) {
                var json = JSON.parse(docusignData[0].json);

                if (json) {
                    this.platforms.docuSignData.url = json.Url;
                    this.platforms.docuSignData.oAuthMethod = json.OAuthMethod;

                    if (json.ClientKey) {
                        this.platforms.docuSignData.integrationKey = json.ClientKey;
                        this.platforms.docuSignData.secretKey = json.SecretKey;
                    }
                }
            },
            DocuSignDemoOnClickAuthorize: function () {
                if (!this.DocuSignDemoIsDataValid()) return;

                this.isAuthorizing = true;
                this.isWaitingAuthorization = true;

                localStorage.setItem(
                    "integrationKeyDocuSignDemo",
                    this.platforms.docuSignDemoData.integrationKey
                );
                localStorage.setItem(
                    "secretKeyDocuSignDemo",
                    this.platforms.docuSignDemoData.secretKey
                );
                localStorage.setItem(
                    "platformUidDocuSignDemo",
                    this.platforms.docuSignDemoData.uId
                );

                let urlDocuSign =
                    this.platforms.docuSignDemoData.url +
                    this.platforms.docuSignDemoData.oAuthMethod +
                    "?response_type=code&scope=signature&client_id=" +
                    this.platforms.docuSignDemoData.integrationKey +
                    "&redirect_uri=" +
                    encodeURIComponent(window.location.origin + "/authorization/");

                var childWindow = window.open(urlDocuSign);

                localStorage.setItem("isDocuSignDemoErr", true);

                var self = this;

                var timer = setInterval(function () {
                    var msg;
                    if (childWindow.closed) {
                        if (localStorage.getItem("isDocuSignDemoErr") == "true") {
                            localStorage.removeItem("isDocuSignDemoErr");
                            self.isAuthorizingErr = true;
                            msg = {
                                type: "warning",
                                text: self.$t("AUTHORIZATIONDOCSIGN.authorizingError"),
                            };
                            window.parent.postMessage(msg, "*");
                            console.warn(localStorage.getItem("errMsg"));
                        } else {
                            self.isAuthorizingErr = false;

                            msg = {
                                type: "success",
                                text: self.$t("AUTHORIZATIONDOCSIGN.authorized"),
                            };
                            window.parent.postMessage(msg, "*");
                        }

                        self.isWaitingAuthorization = false;

                        clearInterval(timer);

                        self.isAuthorizing = false;

                        localStorage.removeItem("isDocuSignDemoErr");
                        localStorage.removeItem("platformUidDocuSignDemo");
                    }
                }, 1000);
            },
            DocuSignDemoIsDataValid() {
                var msg = "";
                if (
                    !this.platforms.docuSignDemoData.integrationKey ||
                    this.platforms.docuSignDemoData.integrationKey.trim().length === 0
                ) {
                    msg = {
                        type: "danger",
                        text: this.$t(
                            "AUTHORIZATIONDOCSIGN.validations.docuSignDemo.integrationKey"
                        ),
                    };
                    window.parent.postMessage(msg, "*");
                    this.platforms.docuSignDemoData.integrationKeyIsErr = true;
                    return false;
                } else this.platforms.docuSignDemoData.integrationKeyIsErr = false;

                if (
                    !this.platforms.docuSignDemoData.secretKey ||
                    this.platforms.docuSignDemoData.secretKey.trim().length === 0
                ) {
                    this.platforms.docuSignDemoData.secretKeyIsErr = true;
                    msg = {
                        type: "danger",
                        text: this.$t("AUTHORIZATIONDOCSIGN.validations.docuSignDemo.secretKey"),
                    };
                    window.parent.postMessage(msg, "*");
                } else this.platforms.docuSignDemoData.secretKeyIsErr = false;

                if (
                    this.platforms.docuSignDemoData.integrationKeyIsErr ||
                    this.platforms.docuSignDemoData.secretKeyIsErr
                )
                    return false;
                else return true;
            },
            DocuSignDemoLoadData: function (docusignData) {
                var json = JSON.parse(docusignData[0].json);

                if (json) {
                    this.platforms.docuSignDemoData.url = json.Url;
                    this.platforms.docuSignDemoData.oAuthMethod = json.OAuthMethod;

                    if (json.ClientKey) {
                        this.platforms.docuSignDemoData.integrationKey = json.ClientKey;
                        this.platforms.docuSignDemoData.secretKey = json.SecretKey;
                    }
                }
            },
            OnLoadAuthorize: function () {
                this.codeZeev = this.$route.params.obj;
                if (this.codeZeev == undefined) return;
                localStorage.setItem("codeZeev", this.codeZeev);
                this.PlatformGetAll();
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .text-align {
        text-align: left;
    }
</style>
